<template>
  <div>
    <p class="caption mb-4" style="color: rgba(0,0,0,0.55)">Defina o tipo de cálculo, as metas e o valor do bônus.</p>

    <div class="d-flex mb-3" style="gap: 10px; align-items: stretch">
      <div style="flex: 1 1 0; border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Tipo de Meta</p>
        <div class="d-flex" style="gap: 6px">
          <button
            v-for="opt in tiposMeta"
            :key="opt.value"
            type="button"
            @click="setTipoMeta(opt.value)"
            class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
            style="cursor: pointer; border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
            :style="form.tipoMeta === opt.value ? 'border-color: #1976d2; background: rgba(25,118,210,0.06); color: #1976d2' : 'border-color: rgba(0,0,0,0.12); background: white; color: rgba(0,0,0,0.6)'"
          >{{ opt.label }}</button>
        </div>
      </div>
      <div style="flex: 1 1 0; border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Tipo de Cálculo</p>
        <div class="d-flex" style="gap: 6px">
          <button
            v-for="opt in tiposCalculo"
            :key="opt.value"
            type="button"
            @click="setTipoCalculo(opt.value)"
            class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
            style="cursor: pointer; border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
            :style="form.tipoCalculo === opt.value ? 'border-color: #1976d2; background: rgba(25,118,210,0.06); color: #1976d2' : 'border-color: rgba(0,0,0,0.12); background: white; color: rgba(0,0,0,0.6)'"
          >{{ opt.label }}</button>
        </div>
      </div>
      <div style="flex: 1 1 0; border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Tipo de Pagamento</p>
        <div class="d-flex" style="gap: 6px">
          <button
            v-for="opt in tiposPagamento"
            :key="opt.value"
            type="button"
            @click="setTipoPagamento(opt.value)"
            class="rounded pa-2 text-center caption font-weight-medium flex-grow-1"
            style="cursor: pointer; border: 2px solid; transition: all 0.2s; font-family: inherit; outline: none; -webkit-appearance: none; appearance: none"
            :style="form.tipoPagamento === opt.value ? 'border-color: #1976d2; background: rgba(25,118,210,0.06); color: #1976d2' : 'border-color: rgba(0,0,0,0.12); background: white; color: rgba(0,0,0,0.6)'"
          >{{ opt.label }}</button>
        </div>
      </div>
    </div>

    <v-alert
      v-if="form.tipoCalculo"
      type="info" dense text class="caption mb-3"
    >
      <div class="mb-1"><strong>Meta:</strong> {{ descricaoTipoMeta }}</div>
      <div v-if="descricaoTipoCalculo" class="mb-1"><strong>Cálculo:</strong> {{ descricaoTipoCalculo }}</div>
      <div><strong>Pagamento:</strong> {{ descricaoTipoPagamento }}</div>
    </v-alert>

    <!-- Modo Coletivo -->
    <template v-if="form.tipoMeta !== 'individual'">
      <div
        v-if="form.indicadoresSelecionados.length > 0"
        class="mb-4"
        style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)"
      >
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Metas por Indicador</p>
        <v-alert v-if="form.indicadoresSelecionados.length > 1" type="warning" dense text class="mb-3 caption">
          <strong>Lembrete:</strong> o bônus só é pago quando <strong>todos</strong> os indicadores abaixo atingirem suas metas individualmente.
        </v-alert>
        <div :style="styleGridMetas">
          <div
            v-for="ind in form.indicadoresSelecionados"
            :key="ind.id_indicador"
            class="pa-3 rounded"
            :class="form.tipoCalculo === 2 ? 'mb-3' : ''"
            style="background: white; border: 1px solid rgba(0,0,0,0.12)"
          >
            <p class="caption font-weight-medium mb-2" style="color: rgba(0,0,0,0.7)">{{ ind.id_indicador }} — {{ ind.indicador }}</p>
            <template v-if="form.tipoCalculo === 2">
              <div class="d-flex justify-space-between align-center mb-2">
                <span class="caption grey--text text--darken-1">Faixas de Realizado</span>
                <v-btn x-small outlined color="primary" @click="adicionarFaixa(ind.id_indicador)">
                  <v-icon x-small class="mr-1">mdi-plus</v-icon>Adicionar Faixa
                </v-btn>
              </div>
              <div v-for="(faixa, idx) in getFaixasIndicador(ind.id_indicador)" :key="idx" class="mb-2 pa-3 rounded" style="background: rgba(0,0,0,0.02); border: 1px solid rgba(0,0,0,0.08)">
                <div class="d-flex align-end" style="gap: 8px">
                  <v-text-field :value="faixa.minimo" @input="atualizarFaixa(ind.id_indicador, idx, 'minimo', $event)" label="Mínimo" type="number" dense outlined style="flex: 1" :hide-details="!getFaixaOrdemErro(ind.id_indicador, idx)" :error-messages="getFaixaOrdemErro(ind.id_indicador, idx)"></v-text-field>
                  <v-text-field :value="faixa.maximo" @input="atualizarFaixa(ind.id_indicador, idx, 'maximo', $event)" label="Máximo" type="number" dense outlined hide-details style="flex: 1"></v-text-field>
                  <v-text-field :value="faixa.bonus" @input="atualizarFaixa(ind.id_indicador, idx, 'bonus', $event)" :label="form.tipoPagamento === 1 ? 'R$ / unidade' : 'Bônus fixo (R$)'" type="number" dense outlined hide-details style="flex: 1"></v-text-field>
                  <v-btn v-if="getFaixasIndicador(ind.id_indicador).length > 2" icon x-small color="error" @click="removerFaixa(ind.id_indicador, idx)" class="mb-1 flex-shrink-0"><v-icon small>mdi-close</v-icon></v-btn>
                </div>
              </div>
              <v-alert v-if="getFaixasIndicador(ind.id_indicador).length < 2" type="warning" dense text class="mt-2 caption mb-0">Adicione pelo menos 2 faixas para continuar.</v-alert>
            </template>
            <template v-else>
              <v-text-field :value="getMetaIndicadorValor(ind.id_indicador, 'metaValor')" @input="setMetaIndicadorValor(ind.id_indicador, 'metaValor', $event)" label="Valor da Meta" type="number" dense outlined placeholder="0" hide-details></v-text-field>
            </template>
          </div>
        </div>
      </div>

      <div v-if="form.tipoCalculo !== 2" class="mb-4" style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Valor do Bônus</p>
        <v-text-field v-model="form.valorBonus" :label="form.tipoPagamento === 1 ? 'R$ / unidade' : 'Bônus fixo (R$)'" prefix="R$" type="number" outlined dense placeholder="0,00" hide-details background-color="white"></v-text-field>
      </div>
    </template>

    <!-- Modo Individual -->
    <template v-else-if="form.indicadoresSelecionados.length > 0 && form.colaboradoresSelecionados.length > 0">

      <!-- Individual — Meta Fixa -->
      <div v-if="form.tipoCalculo !== 2" class="mb-4" style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 10px 12px; background: rgba(0,0,0,0.015)">
        <p class="caption font-weight-bold text-uppercase ma-0 mb-2" style="letter-spacing: 0.05em; font-size: 10px; color: rgba(0,0,0,0.7)">Metas e Bônus Individuais por Colaborador</p>
        <v-alert v-if="form.indicadoresSelecionados.length > 1" type="warning" dense text class="mb-3 caption">
          <strong>Lembrete:</strong> o bônus só é pago quando <strong>todos</strong> os indicadores atingirem suas metas individualmente.
        </v-alert>
        <v-simple-table dense class="elevation-0">
          <template v-slot:default>
            <thead>
              <tr style="background: rgba(0,0,0,0.03)">
                <th class="caption text-left py-2" style="color: rgba(0,0,0,0.7); min-width: 160px">Colaborador</th>
                <th v-for="ind in form.indicadoresSelecionados" :key="ind.id_indicador" class="caption text-left py-2" style="color: rgba(0,0,0,0.7); min-width: 130px">
                  Meta: {{ ind.indicador }}
                </th>
                <th class="caption text-left py-2" style="color: rgba(0,0,0,0.7); min-width: 130px">Bônus</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="colab in form.colaboradoresSelecionados" :key="colab.id_colaborador">
                <td class="py-2" style="color: rgba(0,0,0,0.75)">
                  <span class="body-2">{{ colab.colaborador }}</span>
                  <br>
                  <span class="caption grey--text">{{ colab._funcao }}</span>
                </td>
                <td v-for="ind in form.indicadoresSelecionados" :key="ind.id_indicador" class="py-2">
                  <v-text-field
                    :value="getMetaIndividual(colab.id_colaborador, ind.id_indicador)"
                    @input="setMetaIndividual(colab.id_colaborador, ind.id_indicador, $event)"
                    type="number" dense outlined placeholder="0" hide-details style="min-width: 110px" background-color="white"
                  ></v-text-field>
                </td>
                <td class="py-2">
                  <v-text-field
                    :value="getMetaIndividualBonus(colab.id_colaborador)"
                    @input="setMetaIndividualBonus(colab.id_colaborador, $event)"
                    :label="form.tipoPagamento === 1 ? 'R$/unidade' : 'Fixo (R$)'"
                    prefix="R$" type="number" dense outlined placeholder="0,00" hide-details
                    style="min-width: 110px" background-color="white"
                  ></v-text-field>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <!-- Individual — Faixa Progressiva -->
      <div v-else class="mb-4" style="display: flex; flex-direction: column; gap: 12px">
        <v-alert v-if="form.indicadoresSelecionados.length > 1" type="warning" dense text class="caption mb-0">
          <strong>Lembrete:</strong> o bônus só é pago quando <strong>todos</strong> os indicadores atingirem suas metas individualmente.
        </v-alert>
        <div
          v-for="colab in form.colaboradoresSelecionados"
          :key="colab.id_colaborador"
          style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 12px 14px; background: rgba(0,0,0,0.015)"
        >
          <p class="body-2 font-weight-medium ma-0 mb-1" style="color: rgba(0,0,0,0.75)">{{ colab.colaborador }}</p>
          <p class="caption grey--text ma-0 mb-3">{{ colab._funcao }}</p>
          <div v-for="ind in form.indicadoresSelecionados" :key="ind.id_indicador" class="mb-3">
            <div class="d-flex justify-space-between align-center mb-2">
              <span class="caption font-weight-medium" style="color: rgba(0,0,0,0.7)">{{ ind.id_indicador }} — {{ ind.indicador }}</span>
              <v-btn x-small outlined color="primary" @click="adicionarFaixaIndividual(colab.id_colaborador, ind.id_indicador)">
                <v-icon x-small class="mr-1">mdi-plus</v-icon>Adicionar Faixa
              </v-btn>
            </div>
            <div v-for="(faixa, idx) in getIndividualFaixas(colab.id_colaborador, ind.id_indicador)" :key="idx" class="mb-2 pa-3 rounded" style="background: white; border: 1px solid rgba(0,0,0,0.1)">
              <div class="d-flex align-end" style="gap: 8px">
                <v-text-field :value="faixa.minimo" @input="atualizarFaixaIndividual(colab.id_colaborador, ind.id_indicador, idx, 'minimo', $event)" label="Mínimo" type="number" dense outlined style="flex: 1" :hide-details="!getFaixaOrdemErroIndividual(colab.id_colaborador, ind.id_indicador, idx)" :error-messages="getFaixaOrdemErroIndividual(colab.id_colaborador, ind.id_indicador, idx)"></v-text-field>
                <v-text-field :value="faixa.maximo" @input="atualizarFaixaIndividual(colab.id_colaborador, ind.id_indicador, idx, 'maximo', $event)" label="Máximo" type="number" dense outlined style="flex: 1" :hide-details="!getFaixaMaximoErroIndividual(colab.id_colaborador, ind.id_indicador, idx)" :error-messages="getFaixaMaximoErroIndividual(colab.id_colaborador, ind.id_indicador, idx)"></v-text-field>
                <v-text-field :value="faixa.bonus" @input="atualizarFaixaIndividual(colab.id_colaborador, ind.id_indicador, idx, 'bonus', $event)" :label="form.tipoPagamento === 1 ? 'R$ / unidade' : 'Bônus fixo (R$)'" type="number" dense outlined hide-details style="flex: 1"></v-text-field>
                <v-btn v-if="getIndividualFaixas(colab.id_colaborador, ind.id_indicador).length > 2" icon x-small color="error" @click="removerFaixaIndividual(colab.id_colaborador, ind.id_indicador, idx)" class="mb-1 flex-shrink-0"><v-icon small>mdi-close</v-icon></v-btn>
              </div>
            </div>
            <v-alert v-if="getIndividualFaixas(colab.id_colaborador, ind.id_indicador).length < 2" type="warning" dense text class="mt-1 caption mb-0">Adicione pelo menos 2 faixas para continuar.</v-alert>
          </div>
        </div>
      </div>

    </template>
    <div v-else-if="form.tipoMeta === 'individual'" class="mb-4">
      <v-alert type="info" dense text class="caption">Selecione colaboradores e indicadores nas etapas anteriores para definir metas individuais.</v-alert>
    </div>

    <CustoEstimadoCard
      :custo-estimado="custoEstimado"
      :n-colaboradores="form.colaboradoresSelecionados.length"
      :descricao-preenchido="descricaoPreenchido"
      descricao-vazio="Preencha as metas e o bônus acima para visualizar a simulação de custo."
    />
  </div>
</template>

<script>
import calculoMixin from "./calculoMixin";
import CustoEstimadoCard from "./CustoEstimadoCard";
import { calcPorColaboradorIndicadores, gerarLinhasIndicadores } from "./custoEstimadoUtils";

export default {
  name: "SubEtapaCalculoIndicador",

  mixins: [calculoMixin],

  components: { CustoEstimadoCard },

  props: {
    form: { type: Object, required: true },
    nSemanas: { type: Number, default: 1 }
  },

  data() {
    return {
      metasTick: 0
    };
  },

  watch: {
    "form.metasIndicadores": { deep: true, handler() { this.metasTick++; } },
    "form.valorBonus"() { this.metasTick++; },
    "form.metasIndividuais": { deep: true, handler() { this.metasTick++; } }
  },

  computed: {
    styleGridMetas() {
      if (this.form.tipoCalculo === 2) return {};
      const cols = Math.min(this.form.indicadoresSelecionados.length, 3);
      return {
        display: "grid",
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap: "8px",
        marginBottom: "12px"
      };
    },

    descricaoPreenchido() {
      if (this.form.tipoCalculo === 2) return "Simulação com atingimento da última faixa";
      return this.nSemanas > 1
        ? `Simulação com 100% de atingimento em todas as ${this.nSemanas} semanas`
        : "Simulação com 100% de atingimento para todos";
    },

    custoEstimado() {
      void this.metasTick;
      const form = this.form;
      if (form.tipoMeta === "individual" && form.tipoCalculo !== 2) {
        let total = 0;
        const linhas = [];
        form.colaboradoresSelecionados.forEach(c => {
          const ind = form.metasIndividuais[c.id_colaborador] || {};
          const bonus = parseFloat(ind.valorBonus) || 0;
          const metaMax = form.indicadoresSelecionados.reduce((acc, indicador) => {
            const val = parseFloat(ind.metas && ind.metas[indicador.id_indicador]) || 0;
            return Math.max(acc, val);
          }, 0);
          const custo = form.tipoPagamento === 1 ? bonus * metaMax * (this.nSemanas || 1) : bonus * (this.nSemanas || 1);
          total += custo;
          linhas.push({ label: c.colaborador || String(c.id_colaborador), valor: custo });
        });
        return { porColaborador: null, total, nSemanas: this.nSemanas || 1, linhas };
      }
      const porColaborador = calcPorColaboradorIndicadores(
        form.indicadoresSelecionados, form.metasIndicadores, form.tipoCalculo, form.tipoPagamento, form.valorBonus
      );
      const linhas = gerarLinhasIndicadores(
        form.indicadoresSelecionados, form.metasIndicadores, form.tipoCalculo, form.tipoPagamento, form.valorBonus
      );
      return {
        porColaborador,
        total: porColaborador * (form.colaboradoresSelecionados.length || 1) * (this.nSemanas || 1),
        nSemanas: this.nSemanas || 1,
        linhas
      };
    }
  },

  mounted() {
    this.form.indicadoresSelecionados.forEach(ind => {
      if (!this.form.metasIndicadores[ind.id_indicador]) {
        this.$set(
          this.form.metasIndicadores,
          ind.id_indicador,
          this.form.tipoCalculo === 2
            ? { faixas: [{ minimo: "", maximo: "", bonus: "" }, { minimo: "", maximo: "", bonus: "" }] }
            : { metaValor: "" }
        );
      }
    });
  },

  methods: {
    getFaixasIndicador(idIndicador) {
      const entry = this.form.metasIndicadores[idIndicador];
      return entry && entry.faixas ? entry.faixas : [];
    },

    adicionarFaixa(idIndicador) {
      if (!this.form.metasIndicadores[idIndicador]) {
        this.$set(this.form.metasIndicadores, idIndicador, { faixas: [] });
      } else if (!this.form.metasIndicadores[idIndicador].faixas) {
        this.$set(this.form.metasIndicadores[idIndicador], "faixas", []);
      }
      this.form.metasIndicadores[idIndicador].faixas.push({ minimo: "", maximo: "", bonus: "" });
    },

    removerFaixa(idIndicador, idx) {
      this.form.metasIndicadores[idIndicador].faixas.splice(idx, 1);
    },

    atualizarFaixa(idIndicador, idx, campo, valor) {
      this.$set(this.form.metasIndicadores[idIndicador].faixas[idx], campo, valor);
    },

    getFaixaOrdemErro(idIndicador, idx) {
      if (idx === 0) return "";
      const faixas = this.getFaixasIndicador(idIndicador);
      const atual = faixas[idx];
      const anterior = faixas[idx - 1];
      if (!atual || !anterior || atual.minimo === "" || !anterior.maximo) return "";
      if (parseFloat(atual.minimo) <= parseFloat(anterior.maximo)) {
        return `Mínimo deve ser > ${anterior.maximo} (maior que o máximo da faixa anterior)`;
      }
      return "";
    },

    getMetaIndicadorValor(idIndicador, campo) {
      const entry = this.form.metasIndicadores[idIndicador];
      return entry ? entry[campo] : "";
    },

    setMetaIndicadorValor(idIndicador, campo, valor) {
      if (!this.form.metasIndicadores[idIndicador]) {
        this.$set(this.form.metasIndicadores, idIndicador, {});
      }
      this.$set(this.form.metasIndicadores[idIndicador], campo, valor);
    },

    getMetaIndividual(idColaborador, idIndicador) {
      const entry = this.form.metasIndividuais[idColaborador];
      return entry && entry.metas ? entry.metas[idIndicador] || "" : "";
    },

    setMetaIndividual(idColaborador, idIndicador, valor) {
      if (!this.form.metasIndividuais[idColaborador]) {
        this.$set(this.form.metasIndividuais, idColaborador, { valorBonus: "", metas: {} });
      }
      if (!this.form.metasIndividuais[idColaborador].metas) {
        this.$set(this.form.metasIndividuais[idColaborador], "metas", {});
      }
      this.$set(this.form.metasIndividuais[idColaborador].metas, idIndicador, valor);
    },

    getMetaIndividualBonus(idColaborador) {
      const entry = this.form.metasIndividuais[idColaborador];
      return entry ? entry.valorBonus || "" : "";
    },

    setMetaIndividualBonus(idColaborador, valor) {
      if (!this.form.metasIndividuais[idColaborador]) {
        this.$set(this.form.metasIndividuais, idColaborador, { valorBonus: "", metas: {} });
      }
      this.$set(this.form.metasIndividuais[idColaborador], "valorBonus", valor);
    },

    getIndividualFaixas(idColaborador, idIndicador) {
      const entry = this.form.metasIndividuais[idColaborador];
      const metas = entry && entry.metas;
      return metas && metas[idIndicador] && metas[idIndicador].faixas ? metas[idIndicador].faixas : [];
    },

    _ensureIndividualIndicador(idColaborador, idIndicador) {
      if (!this.form.metasIndividuais[idColaborador]) {
        this.$set(this.form.metasIndividuais, idColaborador, { valorBonus: "", metas: {} });
      }
      if (!this.form.metasIndividuais[idColaborador].metas[idIndicador]) {
        this.$set(this.form.metasIndividuais[idColaborador].metas, idIndicador, { faixas: [] });
      } else if (!this.form.metasIndividuais[idColaborador].metas[idIndicador].faixas) {
        this.$set(this.form.metasIndividuais[idColaborador].metas[idIndicador], "faixas", []);
      }
    },

    adicionarFaixaIndividual(idColaborador, idIndicador) {
      this._ensureIndividualIndicador(idColaborador, idIndicador);
      this.form.metasIndividuais[idColaborador].metas[idIndicador].faixas.push({ minimo: "", maximo: "", bonus: "" });
    },

    removerFaixaIndividual(idColaborador, idIndicador, idx) {
      this.form.metasIndividuais[idColaborador].metas[idIndicador].faixas.splice(idx, 1);
    },

    atualizarFaixaIndividual(idColaborador, idIndicador, idx, campo, valor) {
      this._ensureIndividualIndicador(idColaborador, idIndicador);
      this.$set(this.form.metasIndividuais[idColaborador].metas[idIndicador].faixas[idx], campo, valor);
    },

    getFaixaOrdemErroIndividual(idColaborador, idIndicador, idx) {
      if (idx === 0) return "";
      const faixas = this.getIndividualFaixas(idColaborador, idIndicador);
      const atual = faixas[idx];
      const anterior = faixas[idx - 1];
      if (!atual || !anterior || atual.minimo === "" || !anterior.maximo) return "";
      if (parseFloat(atual.minimo) <= parseFloat(anterior.maximo)) {
        return `Mínimo deve ser > ${anterior.maximo}`;
      }
      return "";
    },

    getFaixaMaximoErroIndividual(idColaborador, idIndicador, idx) {
      const faixas = this.getIndividualFaixas(idColaborador, idIndicador);
      const faixa = faixas[idx];
      if (!faixa || faixa.minimo === "" || faixa.maximo === "") return "";
      // >= e nao >: mesma regra da faixa progressiva coletiva, que aceita
      // faixa de valor unico (de 3 ate 3).
      if (parseFloat(faixa.maximo) < parseFloat(faixa.minimo)) {
        return `Máximo deve ser >= ${faixa.minimo}`;
      }
      return "";
    }
  }
};
</script>
